import React, { useEffect } from "react";
import Sidebar from "../../components/sidebar";
import Header from "../../components/header";
import { useRef, useState } from "react";
import { Form, Button, Row, Col, Spinner } from "react-bootstrap";
import FollowUpReg from "../../components/operator/follow-up-reg";
import FollowUpSearch from "../../components/operator/follow-up-search";

function FollowUp() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState(true);
  const [Id, setId] = useState(null);

  return (
    <div className="d-flex">
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Sidebar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        {search && (
          <FollowUpSearch
            setLoader={setLoader}
            setSearch={setSearch}
            search={search}
            setId={setId}
            name="Follow Up"
            url="patient-details-follow-up-search"
          />
        )}
        {!search && (
          <FollowUpReg setLoader={setLoader} setSearch={setSearch} id={Id} />
        )}
      </div>
    </div>
  );
}

export default FollowUp;
